/* returns
    if user logged in && user_location exists, time in user location

    else {
        time in event location
    }


time and date from MS and local user timezone */

import { useState, useEffect } from 'react';
import momenttz from 'moment-timezone';
import { useSelector } from 'react-redux';
import { Event } from '../../models/Event';
import { CurrentUserReducer, RootReducer } from '../../models/Redux';

interface ReturnType {
    time: string;
    day: string;
    month: string;
    weekDayAndDate: string;
    gmtOffset: string | undefined;
}

const useUserOrLocalTimeHour = (
    request_date: string,
    event: Event,
    isCreator?: boolean,
): { time: ReturnType } => {
    const { user } = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);

    const [timeZone, setTimeZone] = useState<string>('');
    const [time, setTime] = useState<ReturnType>({
        time: '',
        day: '',
        month: '',
        weekDayAndDate: '',
        gmtOffset: '',
    });
    const [gmtOffset, setGmtOffset] = useState<string>();

    useEffect(() => {
        let userTimezone = null;

        try {
            userTimezone = JSON.parse(user.user_location || '');
        } catch (error) {}

        if (
            user &&
            user.user_location &&
            user.user_location.length > 0 &&
            userTimezone &&
            userTimezone.data &&
            userTimezone.data.zoneName &&
            !isCreator
        ) {
            try {
                setTimeZone(userTimezone.data.zoneName);
            } catch (error) {}

            try {
                const gmtPrefix =
                    // eslint-disable-next-line no-nested-ternary
                    userTimezone.data.gmtOffset / 3600 > 0
                        ? 'GMT+'
                        : userTimezone.data.gmtOffset / 3600 === 0
                        ? 'GMT'
                        : 'GMT';

                setGmtOffset(gmtPrefix + (userTimezone.data.gmtOffset / 3600).toString());
            } catch (error) {}
        } else {
            if (event && event.event_location && event.event_location.length > 0) {
                // TIMEZONE OF EVENT LOCATION
                const tz = JSON.parse(event.event_location);
                setTimeZone(tz.data.zoneName);
            }
            // Offset of the browser
            const timedifference = momenttz().toString();
            let gmtPrefix = timedifference.substring(timedifference.indexOf('GMT'));
            gmtPrefix = gmtPrefix.substr(0, 6);
            setGmtOffset(gmtPrefix);
        }
    }, [user, event, isCreator]);

    useEffect(() => {
        let time;
        let day;
        let month;
        let weekDayAndDate;
        if (request_date && request_date.length > 0 && timeZone.length > 0) {
            if (user && user.user_location && user.user_location.length > 0) {
                time = momenttz(parseInt(request_date, 10)).tz(timeZone).format('hh:mm A');
                time = time.charAt(0) === '0' ? time.substr(1) : time;
                day = momenttz(parseInt(request_date, 10)).tz(timeZone).format('DD');
                month = momenttz(parseInt(request_date, 10))
                    .tz(timeZone)
                    .format('MMMM')
                    .substring(0, 3)
                    .toUpperCase();
                weekDayAndDate = `${momenttz(parseInt(request_date, 10))
                    .tz(timeZone)
                    .format('dddd')} ${momenttz(parseInt(request_date, 10))
                    .tz(timeZone)
                    .format('DD-MM-YYYY')}`;
            } else {
                time = momenttz(parseInt(request_date, 10)).format('hh:mm A');
                time = time.charAt(0) === '0' ? time.substr(1) : time;
                day = momenttz(parseInt(request_date, 10)).format('DD');
                month = momenttz(parseInt(request_date, 10)).format('MMMM').substring(0, 3).toUpperCase();
                weekDayAndDate = `${momenttz(parseInt(request_date, 10)).format('dddd')} ${momenttz(
                    parseInt(request_date, 10),
                ).format('DD-MM-YYYY')}`;
            }
            setTime({ time, day, month, weekDayAndDate, gmtOffset });
        }
    }, [gmtOffset, request_date, timeZone, user]);

    return { time };
};

export default useUserOrLocalTimeHour;
